import React, { useState } from 'react';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder } from '@fortawesome/free-solid-svg-icons';
import { FONT_GSS_FUTURA_BOOK } from '@monorepo/shared/src/themes/defaultTheme';

type FileUploadInput = {
  label?: string;
  buttonLabel?: string;
  placeholder?: string;
  accept?: string;
  multiple?: boolean;
  onChange: (event: any) => void;
};

const FileUploadInput: React.FC<FileUploadInput> = ({
  label,
  buttonLabel = 'Select Files',
  placeholder = 'Select files from your computer',
  accept,
  multiple,
  onChange,
}) => {
  const classes = useStyles();
  const [selectedFilesNames, setSelectedFilesNames] = useState<string>('');

  const handleChange = (event) => {
    const fileNames: string[] = [];
    for (let i = 0; i < event.target.files.length; i++) {
      fileNames.push(event.target.files[i].name);
    }
    setSelectedFilesNames(fileNames.join(', '));
    onChange(event);
  };

  return (
    <>
      {label && <label className={classes.label}>{label}</label>}
      <Box component="form" className={classes.root}>
        <InputBase className={classes.input} value={selectedFilesNames} placeholder={placeholder} />
        <>
          <input
            accept={accept}
            className={classes.fileInput}
            id="contained-button-file"
            type="file"
            onChange={handleChange}
            value={undefined}
            multiple={multiple}
          />
          <label htmlFor="contained-button-file">
            <Button
              variant="outlined"
              color="primary"
              component="span"
              className={classes.button}
              startIcon={<FontAwesomeIcon icon={faFolder} className={classes.fileIcon} />}
            >
              {buttonLabel}
            </Button>
          </label>
        </>
      </Box>
    </>
  );
};

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  label: {
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(22),
    fontFamily: FONT_GSS_FUTURA_BOOK,
  },
  fileInput: {
    display: 'none !important',
  },
  input: {
    borderRadius: '4px 0 0 4px',
    borderRightWidth: 0,
    paddingLeft: '12px',
    flex: 1,
    border: 'solid 2px black',
    opacity: 1,
    boxSizing: 'border-box',
    height: theme.typography.pxToRem(38),
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(20),
    fontFamily: FONT_GSS_FUTURA_BOOK,
    color: theme.palette.grey.main,
    pointerEvents: 'none',
  },
  button: {
    borderRadius: '0 4px 4px 0',
    borderWidth: '2px',
  },
  fileIcon: {},
}));

export default FileUploadInput;
